import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import 'reactflow/dist/style.css';

const App = () =>{
return(
    <>
    <Suspense fallback={"Loding...."}>
        <Outlet />
    </Suspense>
    </>
)
    
}

export {App}